<template>
  <div class="row myrow">
    <div class="col-xs-12 col-md-10 col-lg-9 mycol col-full--1490">
      <table class="co-executor co-executor--filter">
        <thead>
          <tr>
            <td style="width: 30px; white-space: nowrap">№ п/п</td>
            <td style="width: 320px;">Продукт</td>
            <td style="width: 380px;">Наименование продукта</td>
            <td style="width: 305px;">ОКПД 2</td>
            <td style="width: 305px;">ТН ВЭД</td>
            <td v-if="currentUser.TYPE_USER !== 'declarer'">
              <p class="content-s-2-label" style="text-align: left; display: flex; align-items: center; gap: 1px">
                Данный продукт имеется в другом действующем проекте
                <VDropdown trigger="click" placement="bottom" popperClass="custom-popper">
                  <a class="info-holder-icon" />
                  <template #popper>
                <span>
                 Просим указать номер проекта, в котором имеется этот продукт, а также указать порядок распределения/расчета ЦПЭ (выручка, налоги) по продукту между проектами
                </span>
                  </template>
                </VDropdown>
              </p>
            </td>
            <td v-if="currentUser.TYPE_USER !== 'declarer'"
                style="padding-left: 14px;">Информация по дубликату</td>
            <td style="width: 30px;"></td>
          </tr>
        </thead>
        <tbody v-for="(item, index) in project.PROJECT_PRODUCTS.items">
          <ProjectProductsV3List
            v-if="editable"
            :item="item"
            :index="index"
            v-bind:key="index"
          ></ProjectProductsV3List>
          <template v-else>
            <tr>
              <td>{{ index + 1 }}</td>
              <td>{{ item.UF_PRODUCT_ID.NAME }}</td>
              <td>{{ item.UF_PRODUCT_TEXT }}</td>
              <td class="td--multiselect-mx-280">
                <template v-for="code in item.UF_OKPD2">
                  {{ code.CODE }} <br />
                </template>
              </td>
              <td class="td--multiselect-mx-280">
                <template v-for="code in item.UF_TN_VED">
                  {{ code.CODE }} <br />
                </template>
              </td>

              <td class="cnt" v-if="currentUser.TYPE_USER !== 'declarer'">
                <span>{{ (item.UF_IS_DOUBLE == 1)?'Да':'Нет' }}</span>
              </td>
              <td v-if="currentUser.TYPE_USER !== 'declarer'"
                  style="padding-left: 14px;">
                <span>{{ item.UF_DOUBLE_TEXT }}</span>
              </td>

              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
      <div class="add-row" v-show="editable">
        <a class="link-add-row" v-on:click="addItem">Добавить запись</a>
      </div>

      <button
        type="button"
        @click="saveProductsProject()"
        v-show="editable"
        class="btn btn-success"
      >
        Сохранить
      </button>
      <button
        type="button"
        @click="getListProducts()"
        v-show="editable"
        class="btn btn-default btn-style-big"
      >
        Отмена
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import ProjectProductsV3List from "@/components/project/form/lists/ProjectProductsV3List";
import { mapGetters } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  name: "technological_line",
  props: ["project", "editable", "programmCode"],
  components: { Multiselect, ProjectProductsV3List },
  data() {
    return {
      listErrors: []
    };
  },
  async created() {
    await this.$store
      .dispatch(FETCH_DIRECTORY, ["sp_project_products_list"])
      .then(async () => {}, this);
  },
  computed: {
    ...mapGetters(["directory", "currentUser"])
  },
  methods: {
    hasError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return true;
        }
      }

      return false;
    },
    errorText(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          return this.listErrors[col][field];
        }
      }
      return "";
    },
    removeError(col, field) {
      if (typeof this.listErrors[col] !== "undefined") {
        if (typeof this.listErrors[col][field] !== "undefined") {
          Vue.delete(this.listErrors[col], field);
        }
      }
      return false;
    },
    addItem() {
      if (typeof this.project.PROJECT_PRODUCTS.items === "undefined") {
        this.project.PROJECT_PRODUCTS = {
          items: []
        };
      }
      this.project.PROJECT_PRODUCTS.items.push({
        UF_PRODUCT_TEXT: "",
        UF_PRODUCT_ID: 0,
        UF_OKPD2: [],
        UF_TN_VED: []
      });
    },
    deleteItem(index) {
      this.project.PROJECT_PRODUCTS.items.splice(index, 1);
    },
    saveProductsProject() {
      this.listErrors = [];
      ProjectsService.saveProductsProject(this.$route.params.id, {
        items: this.project.PROJECT_PRODUCTS.items
      }).then(({ data }) => {
        if (data.error) {
          data.errorArr.forEach(function(text) {
            this.$toasted.show(text.TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });

            if (!this.listErrors[text.DOP_INFO.ROW_NUM]) {
              this.listErrors[text.DOP_INFO.ROW_NUM] = [];
            }

            for (let i = 0; i < text.DOP_INFO.COL.length; i++) {
              this.listErrors[text.DOP_INFO.ROW_NUM][text.DOP_INFO.COL[i]] =
                text.TEXT;
            }
            //this.listErrors[text.DOP_INFO.ROW_NUM][text.DOP_INFO.COL[0]] = text.TEXT;
          }, this);
          if (data.isSetTansactionBD) {
            this.project.PROJECT_PRODUCTS.items = data.items;
          }
          return;
        } else {
          this.$toasted.show("Данные о продукции проекта сохранены", {
            theme: "green",
            position: "bottom-right",
            duration: 3000
          });
          if (data.isSetTansactionBD) {
            this.project.PROJECT_PRODUCTS.items = data.items;
          }

          if (data.infoArr.length) {
            data.infoArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "orange",
                position: "bottom-right",
                duration: 4000
              });
            }, this);
          }
        }
      }, this);
    },
    getListProducts() {
      ProjectsService.getProductsProject(this.$route.params.id).then(
        ({ data }) => {
          if (data) {
            this.project.PROJECT_PRODUCTS.items = data;
          }
        },
        this
      );
    },
    countEntChar(value, limit) {
      if (value) {
        const length = String(value).length;
        return length > limit ? 0 : limit - length;
      }
      return limit;
    }
  }
};
</script>

<style scoped></style>
